import { connect } from 'react-redux'
import BagLabelComponent from '../components/BagLabelComponent.jsx';
import {
  changeBagLabelValue,
  generateBagLabel,
  generateBagLabel2,
  findAllOrderIds,
  cleanBagLabelAlert
} from '../actions';

const mapStateToProps = (state) => ({
  bagLabel: state.getIn(['bagLabelReducer', 'bagLabel']),
  bagLabelValidation: state.getIn(['bagLabelReducer', 'bagLabelValidation']),
  alertStyle: state.getIn(['bagLabelReducer', 'alertStyle']),
  alertMessage: state.getIn(['bagLabelReducer', 'alertMessage']),
  allOrderIds: state.getIn(['fittingReducer', 'allOrderIds']),
})

const mapDispatchToProps = (dispatch) => ({
  generateBagLabel: (bagLabel) => {
    dispatch(generateBagLabel(bagLabel))
  },
  generateBagLabel2: (bagLabel) => {
    dispatch(generateBagLabel2(bagLabel))
  },
  setValue: (id, value) => {
    dispatch(changeBagLabelValue({
      id: id,
      value: value
    }))
  },
  findAllOrderIds: () => {
    dispatch(findAllOrderIds());
  },
  cleanAlert: () => {
    dispatch(cleanBagLabelAlert());
  }
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  bagLabel: stateProps.bagLabel,
  bagLabelValidation: stateProps.bagLabelValidation,
  alertStyle: stateProps.alertStyle,
  alertMessage: stateProps.alertMessage,
  allOrderIds: stateProps.allOrderIds,
  generateBagLabel: () => dispatchProps.generateBagLabel(stateProps.bagLabel),
  generateBagLabel2: () => dispatchProps.generateBagLabel2(stateProps.bagLabel),
  setValue: dispatchProps.setValue,
  findAllOrderIds: dispatchProps.findAllOrderIds,
  cleanAlert: dispatchProps.cleanAlert
})

const BagLabelContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(BagLabelComponent)

export default BagLabelContainer;


// WEBPACK FOOTER //
// ./src/containers/BagLabelContainer.jsx